import { Edit } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { AdminRoleForm } from "./_form";

export const AdminRoleEdit = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("adminrole.update")) return null;

  return (
    <Edit mutationMode="pessimistic" redirect="show">
      <AdminRoleForm isEdit />
    </Edit>
  );
};
